import type {RouteRecordRaw} from "vue-router";

export const routeName = 'IncomingList';

export const route: RouteRecordRaw = {
    name: routeName,
    path: '',
    component: () => import('@/pages/DocumentList'),
    props: {
        status: 'incoming',
    },
    meta: {
        isHide: true,
    }
};